import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import HelpTip from "@/components/HelpTip";
import { toast } from "sonner";

export default function AdminImages() {
    const [items, setItems] = useState([]);
    const [uploading, setUploading] = useState(false);

    const load = async () => setItems((await api.get("/admin/uploads")).data);
    useEffect(() => { load(); }, []);

    const upload = async (files) => {
        setUploading(true);
        try {
            for (const f of files) {
                const fd = new FormData();
                fd.append("file", f);
                await api.post("/admin/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
            }
            toast.success(`Uploaded ${files.length} file(s)`); load();
        } catch (e) { toast.error(e.response?.data?.detail || "Upload failed"); }
        finally { setUploading(false); }
    };

    const copyUrl = (path) => {
        const url = process.env.REACT_APP_BACKEND_URL + "/api/files/" + path;
        navigator.clipboard?.writeText(url).then(() => toast.success("URL copied"), () => toast.error("Copy failed"));
    };

    const del = async (id) => { if (!window.confirm("Delete this image? Any product/banner using it will show a broken image.")) return; await api.delete(`/admin/uploads/${id}`); load(); };

    return (
        <div data-testid="admin-images">
            <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-2">
                    <h1 className="font-display text-4xl tracking-tighter">Images</h1>
                    <HelpTip>All uploaded images in one place. Copy any image's URL to use it elsewhere, or delete unused ones.</HelpTip>
                </div>
                <label className="bg-black text-white px-4 py-2 font-mono text-xs uppercase cursor-pointer">
                    {uploading ? "Uploading…" : "+ Upload Images"}
                    <input type="file" accept="image/*" multiple className="hidden" onChange={(e) => { if (e.target.files?.length) upload(Array.from(e.target.files)); e.target.value = ""; }} />
                </label>
            </div>

            {items.length === 0 ? (
                <div className="border-2 border-black p-10 text-center font-mono text-xs">No images uploaded yet.</div>
            ) : (
                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">
                    {items.map(it => (
                        <div key={it.id} className="border-2 border-black bg-white group relative">
                            <img src={it.url} alt="" className="w-full aspect-square object-cover" loading="lazy" />
                            <div className="p-2 font-mono text-[10px] truncate">{it.original_filename || it.id.slice(0, 8)}</div>
                            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/60 transition flex items-center justify-center gap-2 opacity-0 group-hover:opacity-100">
                                <button onClick={() => copyUrl(it.storage_path)} className="bg-white border-2 border-black px-2 py-1 font-mono text-[10px] uppercase">Copy URL</button>
                                <button onClick={() => del(it.id)} className="bg-white border-2 border-black px-2 py-1 font-mono text-[10px] uppercase">Delete</button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
